import { useForm } from "react-hook-form";
import * as yup from "yup";
import { phoneRegExp } from "../../utils";

export type OfficerFormType = {
  id?: string;
  email: string;
  name: string;
  phoneNumber: string;
  cities: string[];
  beaches: string[];
};

const validationSchema = yup.object<OfficerFormType>().shape({
  id: yup.string(),
  email: yup
    .string()
    .email("Email non corretta")
    .required("Campo obbligatorio"),
  name: yup.string().required("Campo obbligatorio"),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Il numero inserito non è valido")
    .required("Campo obbligatorio"),
  cities: yup.array(yup.string()).default([]).required("Campo obbligatorio"),
  beaches: yup.array(yup.string()).default([]).required("Campo obbligatorio"),
});

const useOfficerForm = (defaultValues?: OfficerFormType) => {
  const form = useForm<OfficerFormType>({ validationSchema, defaultValues });

  return { ...form };
};

export default useOfficerForm;
